// extracted by mini-css-extract-plugin
export default {"card-wrapper":"choose-objects_card-wrapper__XDAhQ","card":"choose-objects_card__CXI2W","p-grayed":"choose-objects_p-grayed__SwZuM","p":"choose-objects_p__a3DFX"};